var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.4648L8 13.4648L8 7.51246L10 7.51246L10 13.4648ZM10 5.53554C10 5.81332 9.90278 6.04546 9.70833 6.23197C9.51389 6.41848 9.27778 6.51173 9 6.51173C8.72222 6.51173 8.48611 6.41848 8.29167 6.23197C8.09722 6.04546 8 5.81332 8 5.53554C8 5.25776 8.09722 5.02165 8.29167 4.82721C8.48611 4.63276 8.72222 4.53554 9 4.53554C9.27778 4.53554 9.51389 4.63276 9.70833 4.82721C9.90278 5.02165 10 5.25776 10 5.53554Z",
    fill: "#278DEC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.35,
    y: 17.35,
    width: 16.7,
    height: 16.7,
    rx: 8.35,
    transform: "rotate(180 17.35 17.35)",
    stroke: "#278DEC",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.fd509e894b0811b888e4763b7441e87f.svg";
export { ForwardRef as ReactComponent };